import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const $ = window.$
export default class SiteMap extends Component {

    static defaultProps = {
        id: null,
        model: null,
        home: null,
        style: null,
        className: null
    };

    static propTypes = {
        id: PropTypes.string,
        model: PropTypes.array,
        home: PropTypes.any,
        style: PropTypes.object,
        className: PropTypes.string
    };

    itemClick(event, item) {
        if (item.disabled) {
            event.preventDefault();
            return;
        }

        if (!item.url) {
            event.preventDefault();
        }

        if (item.command) {
            item.command({
                originalEvent: event,
                item: item
            });
        }
    }

    renderHome() {
        if (this.props.home) {
            const className = classNames('p-breadcrumb-home', { 'p-disabled': this.props.home.disabled }, this.props.home.className);
            const iconClassName = classNames('p-menuitem-icon', this.props.home.icon);

            return (
                <li className={className} style={this.props.home.style, {
                    margin: $.strings.dir === "rtl" ? '0px' : '',
                    marginLeft: $.strings.dir === "rtl" ? '0.857em' : ''
                }} >
                    <a href={this.props.home.url || '#'} className="p-menuitem-link" target={this.props.home.target}
                        onClick={event => this.itemClick(event, this.props.home)}>
                        <span className={iconClassName} style={{ fontWeight: 'bold' }}></span>
                    </a>
                </li >
            );
        }

        return null;
    }

    renderSeparator() {
        return (
            $.strings.dir === "rtl"
                ?
                <li className="p-breadcrumb-chevron pi pi-chevron-left" style={{ fontWeight: 'bold' }}></li>
                :
                <li className="p-breadcrumb-chevron pi pi-chevron-right" style={{ fontWeight: 'bold' }}></li>
        );
    }

    renderMenuitem(item, index) {
        const className = classNames(item.className, { 'p-disabled': item.disabled });
        return (
            <li className={className} style={item.style}>
                <a href={item.url || '#'} className="p-menuitem-link" target={item.target} onClick={event => this.itemClick(event, item)}>
                    <span className="p-menuitem-text" style={{ fontWeight: 'bold' }}>{item.label}</span>
                </a>
            </li>
        );
    }

    renderMenuitems() {
        if (this.props.model) {
            const items = this.props.model.map((item, index) => {
                const menuitem = this.renderMenuitem(item, index);
                const separator = (index === this.props.model.length - 1) ? null : this.renderSeparator();

                return (
                    <React.Fragment key={item.label + '_' + index}>
                        {menuitem}
                        {separator}
                    </React.Fragment>
                );
            });

            return items;
        }

        return null;
    }

    render() {
        const className = classNames('p-breadcrumb p-component', this.props.className);
        const home = this.renderHome();
        const items = this.renderMenuitems();
        const separator = this.renderSeparator();

        return (
            <nav id={this.props.id} className={className} style={this.props.style} aria-label="Breadcrumb">
                <ul>
                    {home}
                    {separator}
                    {items}
                </ul>
            </nav>
        );
    }
}